export var defaultModelData = [
    {
      "modelId": "22713c91-70cf-4f9f-8008-b3d36c0d0db9",
      "modelName": "chair",
      "modelUrl": "https://aurainteract.com/library/agwxr/3d/chair_v4/chair_v4.glb",
      "modelImage": "modelImage/chair.png",
      "placeName": "mesh_7",
      "placeLocation": "floor",
      "modelTextures": [
        {
          "textureId": "0001",
          "textureName": "chair_blue_v1",
          "textureUrl": "https://aurainteract.com/library/agwxr/3d/chair_v4/theme1/chair_a_v4.jpg",
          "buttonImage": "https://aurainteract.com/library/agwxr/2d/chair_a_Button_v4.jpg"
        },
        {
          "textureId": "0002",
          "textureName": "chair_red_v1",
          "textureUrl": "https://aurainteract.com/library/agwxr/3d/chair_v4/theme1/chair_b_v4.jpg",
          "buttonImage": "https://aurainteract.com/library/agwxr/2d/chair_b_Button_v4.jpg"
        },
        {
          "textureId": "0003",
          "textureName": "chair_grey_v1",
          "textureUrl": "https://aurainteract.com/library/agwxr/3d/chair_v4/theme1/chair_c_v4.jpg",
          "buttonImage": "https://aurainteract.com/library/agwxr/2d/chair_c_Button_v4.jpg"
        }
      ],
    },
    {
      "modelId": "2352770c-6eb8-4238-a6cc-a650457f0578",
      "modelName": "sofa",
      "modelUrl": "https://aurainteract.com/library/agwxr/3d/sofa_v4/sofa_v4.glb",
      "modelImage": "modelImage/sofa.png",
      "placeName": "mesh_7",
      "placeLocation": "floor",
      "modelTextures": [
        {
          "textureId": "0001",
          "textureName": "sofa_blue_v1",
          "textureUrl": "https://aurainteract.com/library/agwxr/3d/sofa_v4/theme1/sofa_a_v4.jpg",
          "buttonImage": "https://aurainteract.com/library/agwxr/2d/sofa_a_Button_v4.jpg"
        },
        {
          "textureId": "0002",
          "textureName": "sofa_red_v1",
          "textureUrl": "https://aurainteract.com/library/agwxr/3d/sofa_v4/theme1/sofa_b_v4.jpg",
          "buttonImage": "https://aurainteract.com/library/agwxr/2d/sofa_b_Button_v4.jpg"
        },
        {
          "textureId": "0003",
          "textureName": "sofa_grey_v1",
          "textureUrl": "https://aurainteract.com/library/agwxr/3d/sofa_v4/theme1/sofa_c_v4.jpg",
          "buttonImage": "https://aurainteract.com/library/agwxr/2d/sofa_c_Button_v4.jpg"
        }
      ]
    },
    {
      "modelId": "8beb039d-16c3-4bb3-aec0-d54634eddf80",
      "modelName": "bench",
      "modelUrl": "https://aurainteract.com/library/agwxr/3d/bench_v2/bench_v2.glb",
      "modelImage": "modelImage/bench.png",
      "placeName": "mesh_7",
      "placeLocation": "floor",
    },
    {
      "modelId": "83d625d1-5bdd-4999-8b45-31ee416aa457",
      "modelName": "table",
      "modelUrl": "https://aurainteract.com/library/agwxr/3d/table.glb",
      "modelImage": "modelImage/table.png",
      "placeName": "mesh_7",
      "placeLocation": "floor",
    },
    // {
    //   "modelId": "6297a20b-4aa1-42d3-bf58-eeb610b342b0",
    //   "modelName": "Frame1",
    //   "modelUrl": "https://aurainteract.com/library/agwxr/3d/panting.glb",
    //   "modelImage": "modelImage/frame.png",
    //   "placeName": "mesh_4",
    //   "placeLocation": "wall",
    //   "scale": 2
    // },
    {
      "modelId": "6297a20b-4aa1-42d3-bf58-eeb610b342b1",
      "modelName": "Frame1",
      "modelUrl": "models/screen2.glb",
      "modelImage": "modelImage/Screen.png",
      "placeName": "mesh_4",
      "placeLocation": "wall",
      "scale": 2
    }
  ]